import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { useCart } from "./context/CartContext";

// Wraps every /shop/:shopId/* route. Visiting this page IS the "scan" event
// (whether via camera or a direct link) — it always (re)claims the unlock
// for this shopId in sessionStorage, which the /shop/shops list checks
// against to decide which shop cards are tappable.
export default function ShopScope() {
  const { shopId } = useParams();
  const location = useLocation();
  const { setShopId } = useCart();
  const token = localStorage.getItem("JWTtoken");

  useEffect(() => {
    sessionStorage.setItem("scannedShopId", shopId);
  }, [shopId]);

  useEffect(() => {
    setShopId(shopId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId]);

  if (!token) {
    return (
      <Navigate
        to="/shop/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <Outlet />;
}
